import React, { useRef, useState } from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { intlShape } from '../components/base/IntlProviderWrapper';
import TooltipWithPortal from '../components/base/Tooltip/TooltipWithPortal';
import { STATUS_ENUM } from '../configs';
import { RegNumRuToEn } from './utils';
import CheckBoxInput from '../components/fields/CheckBoxInput/CheckBoxInput';
import { getSettingsData } from '../modules/Settings/reducer';

export const optionClassFormatter = item => {
  let status = item;
  if (typeof item === 'object') {
    status = item.value;
  }
  return 'unknown-state';
};

export const dateFormatter = a => {
  const {
    formatDate,
  } = intlShape;
  if (!a) {
    return '';
  }
  if (typeof a === 'string') {
    return a;
  }
  return formatDate(a, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  });
};

export const timeFormatter = a => {
  const {
    formatDate,
  } = intlShape;
  if (!a) {
    return '';
  }
  return formatDate(a, {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  });
};

export const tooltipFormatter = a => {
  if (!a) {
    return '';
  }
  return <TooltipWithPortal className="tooltip-formatter" content={a} />;
};

export const timeHMFormatter = a => {
  const {
    formatDate,
  } = intlShape;
  if (!a) {
    return '';
  }
  return formatDate(a, {
    hour: 'numeric',
    minute: 'numeric',
  });
};

export const dateTimeFormatter = a => {
  const {
    formatDate,
  } = intlShape;
  if (!a) {
    return '';
  }
  return formatDate(a, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  }).replace(',', ' ');
};

export const statusClassName = status => {
  switch (Number(status)) {
    case STATUS_ENUM.ERROR:
      return 'error';
    case STATUS_ENUM.WARNING:
      return 'warning';
    case STATUS_ENUM.GOOD:
      return 'good';
    default:
      return '';
  }
};

export const textStatusColorFormatter = (text, status) => {
  if (typeof status !== 'undefined') {
    return <span className={statusClassName(status)}>{text}</span>;
  }
  return text;
};

export const regNumberFormatter = text => RegNumRuToEn(text);

export const violationFormatter = v => tooltipFormatter(v.map(i => i.description).join(', ')); // добавть тултип и енам и локаль

export const checkBoxFormatter = (checked, onChange = () => {}, className) => (
  <div className="check-box-field-formatter bordered-checkbox">
    <CheckBoxInput className={className} inputProps={{ value: checked, onChange }} />
  </div>
);

export const RoleFormater = ({ role }) => {
  const {
    roleList = [],
  } = useSelector(getSettingsData);
  const selectedItem = (roleList || []).find(item => String(item.id) === String(role));
  return selectedItem ? selectedItem.name : '';
};

export const getCertStatus = vDiff => {
  if (typeof vDiff === 'undefined') {
    return null;
  }
  const { formatMessage } = intlShape;
  let text = formatMessage({ id: 'metrology.diff.count' }, { count: vDiff });
  let status = 0;
  if (vDiff === 0 || vDiff < 0) { text = formatMessage({ id: 'metrology.diff.not.found' }); status = 2; }
  return (<span className="time-color">{textStatusColorFormatter(text, status)}</span>);
};

export const addressFormatter = address => getAddress(address, Object.keys(address).reverse());

export const addressFormatterShort = address => getAddress(address);

export const getAddress = (address, fields = ['short']) => {
  const { formatMessage } = intlShape;
  try {
    const addrArr = [];
    const addField = field => {
      if (address && address.postal_code && field === 'postal_code') {
        addrArr.push(address.postal_code);
      }

      if (address && address.country && field === 'country') {
        addrArr.push(address.country);
      }

      if (address && address.city && field === 'city') {
        addrArr.push(address.city);
      }

      if (address && address.region && field === 'region') {
        addrArr.push(address.region);
      }

      if (address && address.area && field === 'area') {
        addrArr.push(address.area);
      }

      if (address && address.place && field === 'place') {
        addrArr.push(address.place);
      }

      if (address && address.street && field === 'street') {
        addrArr.push(`${formatMessage({ id: 'pd.street.short' })} ${address.street}`);
      }

      if (address && address.house && field === 'house') {
        addrArr.push(`${formatMessage({ id: 'pd.house.short' })} ${address.house}`);
      }

      if (address && address.external && field === 'external') {
        addrArr.push(`${formatMessage({ id: 'pd.external.short' })} ${address.external}`);
      }

      if (address && address.building && field === 'building') {
        addrArr.push(`${formatMessage({ id: 'pd.building.short' })} ${address.building}`);
      }

      if (address && address.letter && field === 'letter') {
        addrArr.push(`${formatMessage({ id: 'pd.letter.short' })} ${address.letter}`);
      }

      if (address && address.apartment && field === 'apartment') {
        addrArr.push(`${formatMessage({ id: 'pd.apartment.short' })} ${address.apartment}`);
      }
    };

    const shortAddressFields = [
      'city',
      'place',
      'street',
      'house',
      'external',
      'building',
      'apartment',
      'letter',
    ];

    fields.forEach(item => {
      if (item === 'short') {
        shortAddressFields.forEach(addField);
      } else {
        addField(item);
      }
    });

    return addrArr.join(', ');
  } catch (err) {
    window.console.error('Error: build address');
  }

  return '';
};
